import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import banks from '../global/banks';

export default ({ onChange, name, value, error, helperText, disabled, ...props }) => {

    const options = banks?.map(item => ({ label: item.name, id: item.id })) || [];

    const handleChange = (e, data) => {
        console.log(data.id)
        onChange(name, data?.id || '');
    };

    const selectBank = options.filter(item => value === item.id)[0];

    return (
        <>
            <Autocomplete
                sx={{
                    width: "100%",
                    maxWidth: "400px",
                    '@media (max-width: 480px)': {
                        maxWidth: "100%",
                        minWidth: "250px"
                    }
                }}
                options={options}
                disabled={disabled}
                onChange={handleChange}
                value={selectBank || null}
                isOptionEqualToValue={(option, value) => (option.id == value.id)}
                id="select-bank"
                renderInput={params => <TextField {...params} error={error} helperText={helperText} label="Selecione o banco" />}
            />
        </>
    );
};
